(function($) { 
    /**
     * @typedef TrackerOptions
     * @property {Boolean} [show_osm_map=false] Show osm map
     * @property {Number} [osm_map_zoom=15] OSM zoom
     * @property {Number} [osm_tile_size=256] OSM tile size
     */


    /**
     * A Tracker module for ABDOMap
     * @class Tracker
     * @memberof ABDOMap
     * @extends ABDOMap.Component
     */
    $.Tracker = function () {
        // 1. set component name
        this._component_name = "tracker"; 

        // 2. set events
        this._events = {
            ready: "ready",
            finished_tracking: "finished_tracking",
            out_of_bounds: "out_of_bounds",
            bad_precision: "bad_precision",
            reset_tracking: "reset_tracking",
            location_icon_added: "location_icon_added",
            location_icon_removed: "location_icon_removed",
        };

        // 3. initialize flags and other data
        this._watch_id = -1; 
        this._location_overlays = [];
        /** 
         * @property {LocationProvider} location_provider
         */
        this.location_provider = null;

        this._location_loaded = false;
        this._tracker_init_finished = false;
        this._init_complete_emitted = false;
        this._enable_scroll = true;  

        // 4. bound methods
        this.watchPosition = this.watchPosition.bind(this);
        this.watchPositionError = this.watchPositionError.bind(this);
        this._on_overlay_draw = this._on_overlay_draw.bind(this);

        // 5. => see _init

        $.Component.call(this, $.Tracker);
    };

    $.Component.create($.Tracker, /** @lends ABDOMap.Tracker.prototype */ {
        /**
         * @function
         * @param {TrackerOptions} options 
         */
        _init_: function(options) { 
             
            this._options = options || {};
            // this._location_provider_opts = this._options.location_provider || {};
            this.viewers = this._options.viewers || this.parent.viewers || window.viewers || [];
            this.btnStartTracking = this._options.btn_start_tracking || 'button.btn-start-tracking';
            if (typeof(this.btnStartTracking) === 'string') {
                this.btnStartTracking = document.querySelector(this.btnStartTracking);
            } 

            this._max_size = this._options.max_size || 100.0; 
            this._location_icon_width = this._options.location_icon_width;
            if (typeof(this._location_icon_width) !== "number" || this._location_icon_width < 1) {
                this._location_icon_width = 50;
            }
        
            this._reset_msgs(); 

            this.init();
            
            // 4. initialize subcomponents (if any)
            // this has to be done after this._options has been set
            $.Component.call(this, $.Tracker);  
        }, 
        
        _check_init_flags: function() {
            if (this._location_loaded && this._tracker_init_finished) {
                return true;
            }

            return false;
        },

        /**
         * initialize tracker component
         * @memberof Tracker
         * @instance
         */
        init: function() {
            var self = this;
            var viewer;
            // httpsじゃないとGPSが動かないから
            // httpだとhttpsに移動
            // source: https://stackoverflow.com/questions/4723213/detect-http-or-https-then-force-https-in-javascript
            if (location.protocol !== 'file:' && location.protocol !== 'https:') {
                //location.replace(`https:${location.href.substring(location.protocol.length)}`); // IEで動かない
                location.replace('https:' + location.href.substring(location.protocol.length));
            }
 
            if (navigator.geolocation) { 
                if (this.btnStartTracking != null) {
                    this.btnStartTracking.addEventListener(ABDOUtil.getClickHandler(this.btnStartTracking), function(evt){
                        self.btnStartTrackingClick.call(self, evt, this);
                    });
                } 

                var i, viewers_n = this.viewers.length;
                for (i = 0; i < viewers_n; i++) {
                    viewer = this.viewers[i];
                    viewer.addHandler('canvas-drag', this.enableScroll.bind(this, false));
                } 
            }
            
            for (var index = 0; index < this.viewers.length; index++) {
                viewer = this.viewers[index];
                viewer.addHandler('update-viewport', this.updateViewport.bind(this, viewer));
            }
            

            if (this._check_init_flags() && !this._init_complete_emitted) {
                this._emit(this._events.ready);
            } 
        },
        
        enableScroll: function(value) {
            this._enable_scroll = typeof(value) === 'undefined' ? true : value; 
        },

        updateViewport: function(viewer, evt) {
            // 位置情報の精度半径を更新
            var overlays = this._location_overlays;
            for (var index = 0; index < overlays.length; index++) {
                var overlay = overlays[index];
                var location_accuracy_element = overlay.element.querySelector('.location-accuracy');
                if (location_accuracy_element) {
                    var resolution = overlay.element.clientWidth / overlay.element.dataset.size; // px / m
                    var accuracy_size = resolution*location_accuracy_element.dataset.accuracy;
                    var offset = accuracy_size*-0.5;

                    location_accuracy_element.style.width = accuracy_size + 'px';
                    location_accuracy_element.style.height = accuracy_size + 'px';
                    location_accuracy_element.style.left = offset + 'px';
                    location_accuracy_element.style.top = offset + 'px';

                }
            }
        },

        _show_toast: function(id) {
            var toastElement = document.getElementById(id);
            if (toastElement == null || toastElement.classList.contains('show')) {
                return;
            }
            jQuery(toastElement).toast('show');
        },
        _toast_hide_if_shown: function(id) {
            var toastElement = document.getElementById(id);
            if (toastElement == null || toastElement.classList.contains('show')) {
                jQuery(toastElement).toast('hide');
            }
        },
        // ユーザーのプラットフォームを検出するための関数
        guess_ios: function() {
            var ios_platforms = [
                'iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'];
            return ios_platforms.includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        },
        guess_android: function() {
            var ua = navigator.userAgent.toLowerCase();
            return ua.indexOf("android") > -1;
        },
        guess_other: function() {
            return !this.guess_android() && !this.guess_ios();
        }, 
        addLocationOverlays: function(viewer, location) {
            var i, overlay_id;
            for (i = 0; i < this.viewers.length; i++) {
                if (viewer == this.viewers[i]){
                    overlay_id = 'currentLocation-' + i;
                    break;
                }  
            }

            var viewport_deltas = viewer.viewport.deltaPointsFromPixels(new OpenSeadragon.Point(this._location_icon_width, this._location_icon_width));
            
            var icon_size_m = viewer.abdo.localization.estimate_size(location, viewport_deltas.x);

            var locationOverlay = document.createElement('div');
            locationOverlay.classList.add('location-overlay'); 
            locationOverlay.id = overlay_id;
            locationOverlay.dataset.x = location.x;
            locationOverlay.dataset.y = location.y;
            locationOverlay.dataset.size = icon_size_m;
            
            var accuracyDiv = document.createElement('div');
            accuracyDiv.classList.add('location-accuracy'); 
            locationOverlay.appendChild(accuracyDiv);

            var imgdiv = document.createElement('div');
            imgdiv.classList.add('icon-location');  
            locationOverlay.appendChild(imgdiv);

            var orientation_div = document.createElement('div');
            orientation_div.classList.add('abdo-orientation');  
            locationOverlay.appendChild(orientation_div);  
            
            document.body.appendChild(locationOverlay);

            viewer.addOverlay({
                element: locationOverlay,
                location: location,
                width: this._location_icon_width,
                height: this._location_icon_width,
                onDraw: this._on_overlay_draw
            });

            var added_overlay = viewer.getOverlayById(locationOverlay.id);
            added_overlay.viewer_index = i;
            added_overlay.viewer = viewer;
            this._location_overlays.push(added_overlay); 

            var abdo = ABDOUtil.get_abdo(viewer);
            if (abdo) {
                abdo.location_overlay = added_overlay;
            }

            return added_overlay;
        },

        _on_overlay_draw: function(position, size, element) {
            // ABDOUtil._resize_overlay(size, this.parent.overlay._max_size);
            // element.style.width = size.x + 'px';
            // element.style.height = size.y + 'px';

            element.style.width = this._location_icon_width + "px";
            element.style.height = this._location_icon_width + "px";

            // top and left set to 0 to use CSS translate later
            if (!element.style.left) {
                element.style.left = '0px';
            }

            if (!element.style.top) {
                element.style.top = '0px';
            }

            element.style.transform = 'translateX(' + position.x + 'px) translateY(' + position.y + 'px)';
        },

        _removeLocationOverlays: function () {  
            for (var index = 0; index < this._location_overlays.length; index++) {
                var overlay = this._location_overlays[index];
                this.viewers[overlay.viewer_index].removeOverlay(overlay.element.id);
                overlay.element.parentNode.removeChild(overlay.element); 
            }

            this._location_overlays = [];
            
            this._emit(this._events.location_icon_removed);
        },

        _get_leading_viewer: function() {
            if (typeof(this.parent.abdo_dual) !== "undefined") { 
                return this.parent.abdo_dual._get_smallest_viewer();
            }
            else if (this.viewers.length > 0) {
                return this.viewers[0];
            }

            return null;
        },

        btnStartTrackingClick: function(evt, btn) {
            var overlays = this._location_overlays; 
            // 追跡はすでに始まっているから現在地に移動してから辞めます
            if (overlays.length > 0) {
                var currentLocationElement = overlays[0].element;
                // var location = ABDOUtil.getPointFromDataset(currentLocationElement);
                overlays[0].viewer.viewport.panTo(overlays[0].location);
                this.enableScroll();

                // this._emit(this._events.finished_tracking, {
                //     detail: {
                //         location: location,
                //         position: null
                //     }
                // });
                
                return;
            }

            
            if (this._watch_id < 0) {
                //start_rotating();
                var self = this;
 
                var geolocation_options = {
                    enableHighAccuracy: true,
                    timeout: 1000,
                    maximumAge: 0,
                };
                this.enableScroll();
                this._reset_msgs();
                
                this._watch_id = navigator.geolocation.watchPosition(
                    this.watchPosition, 
                    this.watchPositionError,
                    geolocation_options);
            }
            else {
                navigator.geolocation.clearWatch(this._watch_id);
                this._watch_id = -1;
            }
        }, 

        _reset_msgs: function() {
            this._messages = {
                _out_of_bounds : {
                    _shown: false
                },
                _bad_precision : {
                    _shown: false
                },
            };
        },

        _check_bounds: function(viewer, gps_position, location) { 
            var bounds = viewer.world.getHomeBounds();
            var viewport_ok = bounds.containsPoint(location);
            // var gps_ok = viewer.abdo.localization.check_bounds_gps(gps_position.coords.longitude, gps_position.coords.latitude);
            var gps_ok = true; // disable due to problems with distorted maps
            if (!viewport_ok || !gps_ok)  { 
                this._show_out_of_bounds();

                this._emit(this._events.out_of_bounds);

                return false;
            }
            
            this._hide_out_of_bounds(); 

            return true;
        },

        _show_out_of_bounds: function() {
            if (!this._messages._out_of_bounds._shown) {
                this._show_toast('toastOutofBounds'); 
                this._messages._out_of_bounds._shown = true;
            }

            if (this._location_overlays.length > 0) {
                this._removeLocationOverlays();
            }

            this._emit(this._events.out_of_bounds);
        },

        _hide_out_of_bounds: function() {
            this._messages._out_of_bounds._shown = false;
            this._toast_hide_if_shown('toastOutofBounds');
        },
        

        _check_precision: function(gps_position) {
            // 現在地を表示ボタンのデータ要素でdata-max-accuracyの閾値でこの表示が出ます
            var max_accuracy = 500;
            if (this.btnStartTracking) {
                max_accuracy = parseFloat(this.btnStartTracking.dataset.maxAccuracy);
            }

            if (gps_position.coords.accuracy > max_accuracy) { 
                if(!this._messages._bad_precision._shown) {
                    this._show_toast('toastBadPrecision');
                    this._messages._bad_precision._shown = false;
                }
                
                if (this._location_overlays.length > 0) {
                    this._removeLocationOverlays();
                }

                this._emit(this._events.bad_precision);
                
                return false;
            }
            else {
                this._toast_hide_if_shown('toastBadPrecision');
            }

            return true;
        },

        /**
         * Marks GPS position in a viewer
         * @function
         * @param {OpenSeadragon.Viewer} viewer 
         * @param {GeolocationCoordinates} gps_position 
         * @param {OpenSeadragon.Point} location   
         * @returns 
         */
        markPosition: function(viewer, gps_position, location) {  
            // 精度が悪いときはユーザーに警報し、現在地のアイコンを削除する
            if (!this._check_precision(gps_position)) {
                return;
            }

            // 範囲外になると警報を表示
            if (!this._check_bounds(viewer, gps_position, location)) { 
                return;
            } 

            // オーバーレイがなければ追加する
            var added_overlay = null;
            if (this._location_overlays.length < this.viewers.length) {
                added_overlay = this.addLocationOverlays(viewer, location); 
                
                if (this._enable_scroll) {
                    // viewer.viewport.panTo(location).zoomTo($._get_default_zoom());
                    viewer.viewport.panTo(location);
                } 
        
                this._emit(this._events.location_icon_added);
            } 
            
            // オーバーレイ情報の更新
            for (var index = 0; index < this._location_overlays.length; index++) {
                var overlay = this._location_overlays[index];

                var location_accuracy_element = overlay.element.querySelector('.location-accuracy');
                if (location_accuracy_element) {
                    location_accuracy_element.dataset.x = location.x;
                    location_accuracy_element.dataset.y = location.y;
                    location_accuracy_element.dataset.accuracy = gps_position.coords.accuracy;
                }

                if (!added_overlay) {
                    overlay.element.dataset.x = location.x;
                    overlay.element.dataset.y = location.y;
                    viewer.updateOverlay(overlay.element, location);
                }
            }

            if (this._enable_scroll) {
                viewer.viewport.panTo(location);
            } 

            var accuracyElement = document.getElementById('accuracy');
            if (accuracyElement != null) {
                accuracyElement.innerText = gps_position.coords.accuracy.toFixed(2) + "m";
            } 

        }, 
        
        /**
         * Listens to GPS position
         * @function
         * @param {GeolocationPosition} position   
         */
        watchPosition: function(position) {
            var dlgPermissionDenied = document.getElementById('dlgPermissionDenied');
            jQuery(dlgPermissionDenied).modal('hide');

            if (this.location_provider != null) {
                // add position to each viewer
                var i,viewer;
                for (i = 0; i < this.viewers.length; i++) {
                    viewer = this.viewers[i];
                    var localization = viewer.abdo.localization;
                    var lonlat = localization.lonlat2vp(position.coords.longitude, position.coords.latitude);
                    if (lonlat) {
                        
                        var vp_point = new OpenSeadragon.Point(
                            lonlat[0], lonlat[1]
                        ); 
                        
                        // if (localization.has_elevation()) {
                            // var elevation =  localization.get_elevation(vp_point.x, vp_point.y);
                            //console.log(`${position.coords.longitude},${position.coords.latitude}, ${elevation}`); 
                        // } 
                        
                        this.markPosition(viewer, position, vp_point);

                        this._emit(this._events.finished_tracking, {
                            detail: {
                                location: vp_point,
                                position: position,
                                viewer: viewer
                            }                
                        });
                    }
                    else {
                        console.log("GPS変換の精度の限界です");
                    }
                }
               
            }
            else {
                console.log('位置情報の変換が読み込まれていない');
            } 
        },

        watchPositionError: function(error, obj) {
            if (error.code == GeolocationPositionError.PERMISSION_DENIED) {
                if (this.guess_ios()) {
                    jQuery('#collapse-iphone').collapse();
                }
                else if (this.guess_android()) {
                    jQuery('#collapse-android').collapse();
                }
                else {
                    jQuery('#collapse-pc').collapse();
                }
                
                jQuery('#dlgPermissionDenied').modal('show');
            }
            else {
                console.dir(error);
                // POSITION_UNAVAILABLEかTIMEOUT
            }
            
            // delete current watch
            if (this._watch_id >= 0) {
                navigator.geolocation.clearWatch(this._watch_id);
                this._watch_id = -1;
            }
            
        },
        resetTracking: function(callback) {
            if(this._watch_id >= 0) {
                navigator.geolocation.clearWatch(this._watch_id);
                this._watch_id = -1;
                this._removeLocationOverlays();
                
            }

            if (typeof(callback) !== 'undefined' && callback != null) {
                callback();
            }

            // remove location overlays
            var i, viewer;
            for(i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                viewer.abdo.location_overlay = null; 
            }

            this._emit(this._events.reset_tracking);
        }
    }, $.OSD);
})(ABDOMap);